module.exports = __webpack_public_path__ + "img/DNARepair-BRCA_10X_WTA.13c659c3.png";